<script lang="ts">
    import Box from '../_wrappers/Box.svelte';
    import { NORMALIZE_CSS } from './constants';
    import unescape from 'lodash/unescape';

    // Utils
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    // Types
    import type { TransitionEffect } from '$lib/types/Theme';

    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let box = {};
    export let bgColor = 'transparent';
    export let provider = '';
    export let head = '';
    export let body = '';

    let iframeContainer: HTMLIFrameElement;
    let rsObserver: ResizeObserver;

    $: if (iframeContainer && !rsObserver) {
        requestAnimationFrame(() => {
            const { contentWindow: window } = iframeContainer;

            if (!window || typeof window === 'undefined') {
                return;
            }

            const headElem = window.document.getElementsByTagName('head')[0];
            const bodyElem = window.document.getElementsByTagName('body')[0];

            let rawHeadCode = unescape(head);
            let rawBodyCode = unescape(body);

            window.document.body.style.display = 'flex';
            window.document.body.style.justifyContent = 'center';
            window.document.body.style.alignItems = 'flex-start';

            const headNode = window.document
                .createRange()
                .createContextualFragment(
                    `${NORMALIZE_CSS}<style>body > a {display:inline-block;}body > .trustpilot-widget{width:100%;}a[href*="provenexpert.com"]{width:100%;display:inline-flex;justify-content:center;}a[href*="provenexpert.com"] > img{max-width:100%}</style>${rawHeadCode}`,
                );

            rsObserver = new ResizeObserver((entries) => {
                const content = entries[0].contentRect;
                const { height } = content;

                iframeContainer.style.height = `${height}px`;
            });

            headElem.innerHTML = '';
            bodyElem.innerHTML = '';

            headElem.appendChild(headNode);

            if (provider === 'google-maps') {
                const extractIframeSrc = (iframeString: string) => {
                    const urlPattern = new RegExp('<iframe src="(https[^"]+)"');
                    const match = iframeString.match(urlPattern);
                    return match ? match[1] : null;
                };
                const iframeSrc = extractIframeSrc(rawBodyCode);

                if (!iframeSrc) {
                    window?.rollbar?.error(`Google Maps Embed Error`, {
                        data: {
                            error: JSON.stringify(body),
                        },
                    });
                    return;
                }

                iframeContainer.width = '100%';
                iframeContainer.style.border = '0';
                iframeContainer.style.aspectRatio = '4/3';
                iframeContainer.loading = 'lazy';
                iframeContainer.referrerPolicy = 'no-referrer-when-downgrade';
                iframeContainer.src = iframeSrc;
            } else {
                const bodyNode = window.document
                    .createRange()
                    .createContextualFragment(rawBodyCode);
                bodyElem.appendChild(bodyNode);
            }

            const contentElem = window.document.body.firstElementChild;

            if (contentElem) {
                rsObserver.observe(contentElem);
            }
        });
    }

    const embedBorderRadiusClass = getBorderRadius('embed');
</script>

{#if head || body}
    <Box {...box} backgroundColor={bgColor} {transitionDelay} {transitionEffect}>
        <div class="flex justify-center">
            <iframe
                bind:this={iframeContainer}
                class={`${embedBorderRadiusClass} w-full transition-all`}
                title={`${provider}-embed`}
            />
        </div>
    </Box>
{/if}
